import { ReactNode, useEffect, useRef } from 'react';
import { css as emotionCSS } from '@emotion/react';
//TODO: use DS Button
// import Button, { ButtonProps } from 'components/molecules/Button';
import { Button, ButtonProps } from '@mildang/mui';
import { DialogContentText } from '@mildang/mui';
import { DialogHeader, DialogBody, DialogFooter } from 'components/molecules/dialog';

const dialogContentTextStyle = emotionCSS`
  white-space: pre-wrap;
`;

export interface ConfirmDialogContentProps {
  title: ReactNode;
  description: ReactNode;
  dismissButtonProps?: ButtonProps;
  confirmButtonProps?: ButtonProps;
  color?: 'primary' | 'secondary' | 'error';
}

const ConfirmDialogContent = (props: ConfirmDialogContentProps) => {
  const { title, description, dismissButtonProps, confirmButtonProps, color = 'error' } = props;
  const confirmButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    confirmButtonRef.current?.focus();
  }, []);

  const handleConfirmButtonKeyDown: ButtonProps['onKeyDown'] = (event) => {
    confirmButtonProps?.onKeyDown?.(event);

    if (event.defaultPrevented) return;

    if (event.key === 'Enter') {
      event.preventDefault();
      confirmButtonRef.current?.click();
    }
  };

  return (
    <>
      <DialogHeader css={dialogContentTextStyle}>{title}</DialogHeader>
      <DialogBody>
        <DialogContentText css={dialogContentTextStyle} color="text.secondary">
          {description}
        </DialogContentText>
      </DialogBody>
      <DialogFooter>
        {dismissButtonProps && <Button {...dismissButtonProps} />}
        {confirmButtonProps && (
          <Button
            ref={confirmButtonRef}
            variant="contained"
            color={color}
            type="submit"
            {...confirmButtonProps}
            onKeyDown={handleConfirmButtonKeyDown}
          />
        )}
      </DialogFooter>
    </>
  );
};

export default ConfirmDialogContent;
